import { motion } from "framer-motion";
import { Instagram, Music2, Heart, MessageCircle, Send, Bookmark, BadgeCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { IMG, IG_HANDLE } from "../config";

const POSTS = [
  { img: IMG.potret, caption: "Pelayanan administrasi pagi ini. Pintu balai desa selalu terbuka!", likes: "482", comments: "29", tag: "#CianjayMelayani", time: "2 jam lalu" },
  { img: IMG.ronda, caption: "Kopi hangat dan diskusi ronda malam bersama warga Dusun 3. Tetap siaga!", likes: "721", comments: "54", tag: "#JagaMalam24Jam", time: "Kemarin" },
  { img: IMG.wota, caption: "Malam mingguan bareng pemuda & teman-teman Wota Cianjay. Energinya luar biasa!", likes: "1.204", comments: "142", tag: "#RuangEkspresiPemuda", time: "2 hari lalu" },
  { img: IMG.mancing, caption: "Obrolan gayeng bareng Mancing Mania Cianjay di kolam warga.", likes: "639", comments: "41", tag: "#MancingManiaCianjay", time: "3 hari lalu" },
  { img: IMG.bantuan, caption: "Penyaluran bantuan langsung ke tangan para lansia. Sehat selalu, Mbah!", likes: "988", comments: "88", tag: "#BantuanBagiWarga", time: "4 hari lalu" },
];

export const SocialFeed = () => (
  <section id="jejak" data-testid="socialfeed-section" className="py-24 sm:py-32 bg-surfacewarm border-y border-line transition-colors duration-500 overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading
          bab="Lapangan"
          label="Dokumentasi Harian"
          title="Ikuti Jejak Langkah di Lapangan Hari Ini"
          testid="socialfeed"
        />
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="flex items-center gap-3"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2.5 text-sm font-semibold" data-testid="socialfeed-ig-handle">
            <Instagram size={15} className="text-terra" /> {IG_HANDLE}
          </span>
          <span className="hidden sm:inline-flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2.5 text-sm font-semibold" data-testid="socialfeed-tiktok-handle">
            <Music2 size={15} className="text-forest" /> TikTok
          </span>
        </motion.div>
      </div>
    </div>

    <div className="mt-12 flex gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory px-4 sm:px-6 lg:px-[max(1.5rem,calc((100vw-80rem)/2+1.5rem))] pb-4" data-testid="socialfeed-track">
      {POSTS.map((p, i) => (
        <motion.article
          key={i}
          data-testid={`socialfeed-card-${i}`}
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: Math.min(i * 0.08, 0.4), ease: [0.16, 1, 0.3, 1] }}
          className="snap-start shrink-0 w-[270px] sm:w-[300px] rounded-3xl border border-line bg-surface overflow-hidden shadow-[0_10px_30px_rgba(30,58,43,0.08)] hover:-translate-y-1.5 transition-transform duration-300"
        >
          <div className="flex items-center gap-2.5 px-4 py-3">
            <img src={IMG.potret} alt="avatar" className="w-8 h-8 rounded-full object-cover object-top border border-line" />
            <span className="text-xs font-bold flex items-center gap-1">
              mulyono.cianjay <BadgeCheck size={13} className="text-terra" fill="currentColor" stroke="var(--surface)" />
            </span>
            <span className="ml-auto text-[10px] text-soft">{p.time}</span>
          </div>
          <img src={p.img} alt={p.caption} className="w-full aspect-square object-cover" loading="lazy" />
          <div className="px-4 py-3.5">
            <div className="flex items-center gap-3.5 text-ink">
              <Heart size={18} className="hover:text-terra transition-colors cursor-pointer" />
              <MessageCircle size={18} className="hover:text-terra transition-colors cursor-pointer" />
              <Send size={18} className="hover:text-terra transition-colors cursor-pointer" />
              <Bookmark size={18} className="ml-auto hover:text-terra transition-colors cursor-pointer" />
            </div>
            <p className="mt-2.5 text-xs font-bold">{p.likes} suka</p>
            <p className="mt-1 text-xs leading-relaxed text-ink/80">
              <span className="font-bold">mulyono.cianjay</span> {p.caption}
            </p>
            <p className="mt-1.5 text-xs font-semibold text-terra">{p.tag}</p>
            <p className="mt-1 text-[11px] text-soft">Lihat semua {p.comments} komentar</p>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
